import { ISO_DATETIME, ISO_DATE } from './consts';
import { isValidDate, hasTimezone } from './helpers';

/**
 * `parseDate` converts `input` to native JS Date object.
 * @param input - UNIX epoch in milliseconds or ISO 8601.
 * @returns `Date` equivalent of `input`.
 */
export const parseDate = (input: number | string): Date => {
  // temporary typeguarding until all codes are converted to TS.
  if (typeof input !== 'number' && typeof input !== 'string') {
    throw new TypeError(
      `'input' must be either number or string. Got: ${input}`,
    );
  }

  let _input: number | string = input;
  if (typeof _input === 'string') {
    if (ISO_DATETIME.test(_input) || ISO_DATE.test(_input)) {
      _input = hasTimezone(_input) ? _input : `${_input}Z`;
    }
  }

  const result = new Date(_input);

  if (!isValidDate(result)) {
    throw new Error(`${JSON.stringify(input)} is not a parsable date.`);
  }

  return result;
};
